import { Avatar, Col, Icon, Popover, Row, Tooltip } from "antd";
import React, { Component } from "react";
import moment from "moment";
export default class SingleMessagesThread extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messages:[],
      style1: { display: "none" },
      style2: { display: "block"}
    };
  }
componentDidMount=()=>{
  let { item, chatClient } = this.props;
  setTimeout(async () => {
   let chatThreadClient = chatClient.getChatThreadClient(item.threadId);
    const messages = chatThreadClient.listMessages();
    for await (const message of messages) {
      chatThreadClient.getMessage(message.id).then((x) => {
        this.setState({
          messages: [...this.state.messages, x],
        });
      });
    }
  }, 100);
  
}
handleMouseEnter1 = () => {
  this.setState({
    style1: { display: "block" },
    style2: { display: "none" },

  });
};

handleMouseLeave1 = () => {
  this.setState({
    style1: { display: "none" },
    style2: { display: "block" },
  });
};

  render() {

    let { item,DeleteAzureThreads,RemoveParticipants } = this.props;
    return <Row span={24}
    onMouseEnter={this.handleMouseEnter1}
    onMouseLeave={this.handleMouseLeave1}>
        <Col span={20} style={{marginTop:"-10px"}}>
          <Tooltip
            placement="top"
            title={
              item.participants.length === 1
                ? item.participants[0].name
                : item.participants.map((x, index) => {
                  return (
                    x.name +
                    (item.participants.length - 1 !== index
                      ? ", "
                      : "")
                  );
                })
            }
          >
              <Avatar style={{ backgroundColor: "#4e5694", marginTop:"15px" }}>
                {item.participants.length === 1 ? (
                  item.participants[0].name
                    .split(" ")
                    .map((item) => item.charAt(0))
                    .join("")
                    .toUpperCase()
                ) : (
                  <Row span={24}>
                    {" "}
                    {item.participants.map((x, i) => {
                      return (
                        <Col key={i} span={12}>
                          {x.name.charAt(0).toUpperCase()}
                        </Col>
                      );
                    })}
                  </Row>
                )}
              </Avatar>

              <span
                style={{
                  // fontSize: "17px",
                  paddingLeft: "10px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {item.participants.length === 1
                  ? item.participants[0].name
                  : item.participants.map((x, index) => {
                    if (index < 2) {
                      return (
                        x.name.split(" ")[0] +
                        (item.participants.length - 1 !== index
                          ? ", "
                          : "")
                      );
                    } else {
                      if (index > 2) {
                        return "";
                      }
                      return "+" + (item.participants.length - 2);
                    }
                  })}
              </span>
              <p style={{marginLeft:"40px", marginTop:"-15px", color:"black", fontSize:"13px", font:"small-caption", overflow:"hidden", textOverflow:"ellipsis"}}
              dangerouslySetInnerHTML={{ __html:this.state.messages.sort(((a, b) => b.createdOn < a.createdOn ? -1: 1)).find(x=>x.content&&x.content.message)&&
                this.state.messages.sort(((a, b) => b.createdOn < a.createdOn ? -1: 1)).find(x=>x.content&&x.content.message).content&&
                this.state.messages.sort(((a, b) => b.createdOn < a.createdOn ? -1: 1)).find(x=>x.content&&x.content.message).content.message 
                }}></p>
          </Tooltip>
       </Col>
        <Col span={4} style={this.state.style2} >
                      {this.state.messages
                  .map((x, i) => {
                    if (x.content)
                      return (
                        
                        <Row key={i}>
                          {x.content &&
                          x.content.message &&
                            <div style={{fontSize:"13px", marginTop:"-10px",marginLeft:"-5px"}}>
                               {moment().diff(moment(x.createdOn), "hour") <= 12
                               ? moment(x.createdOn).format("LT")
                               : moment(x.createdOn).format("DD-MM")}
                                </div>
                          }
                        </Row>
                      );
                  })}</Col>

        <Col span={4}  style={this.state.style1}>
          <Popover trigger="hover"
            content={
              <div>
                {item.participants.length >
                  1 && (
                      <p><i
                    onClick={() => {
                      RemoveParticipants();
                    } }
                    className="fa fa-sign-out"
                    aria-hidden="true"
                    style={{ color: "black" }}
                  >
                    Leave
                  </i></p>
                  )}

                  <i
                    onClick={() => {
                      DeleteAzureThreads();
                    }}
                    className="fa fa-trash"
                    aria-hidden="true"
                    style={{ color: " #cf1322" }}
                  >
                    {" "}
                    Delete
                  </i>
              </div>
            }
            placement="bottom"
          >
            <Icon
              style={{
                color: "black",
                marginTop: "8px",
                float: "right",
                fontSize: '23px '
              }}
              type="ellipsis"
            />
          </Popover>
        </Col>
      </Row>

  }
}